import React, { ReactElement, Suspense, useContext, useEffect, useState } from 'react'
import styled from 'styled-components';
import {
    CaretRightFilled,
    CaretLeftFilled
} from '@ant-design/icons';
import { AppSettingsContext } from '../../App/AppSettingsContextContainer';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

interface IProps {
    children: ReactElement[]
}

export interface ISidePanelContainerProps {
    isOpen: boolean,
    isMobile?: boolean
}

const SidePanelContainer = styled.div<ISidePanelContainerProps>`    
    width: ${props => props.isOpen ? "min(100%, 50em)" : "5px"};
    overflow-y: scroll;
    overflow-x: hidden;
    height: ${props => props.isOpen ? (props.isMobile ? "100%" : "auto") : "auto"};
    display: flex;
`;

const SidePanelBorderContainer = styled.div`
    background-color: green;
    width: 5px;
    height: 100%;
`;

const ContentsContainer = styled.div<ISidePanelContainerProps>`
    height: ${props => props.isOpen ? "500px" : 0};
    width: ${props => props.isOpen ? "100%" : 0};
    padding-top:  ${props => !props.isOpen && props.isMobile ? 0 : "2em"};
    padding-right: ${props => props.isOpen ? (props.isMobile ? "0.5em" : "2em") : 0};
    padding-left: ${props => props.isOpen ? (props.isMobile ? "0.5em" : "2em") : 0};
    /* overflow: ${props => props.isMobile ? "hidden" : "none"}; */
`;

const SidePanelToggleControl = styled.div<ISidePanelContainerProps>`
    top: 50%;
    position: absolute;
    margin-left: ${props => props.isOpen ? "calc((-20px))" : "-20px"};
    background-color: green;
    width: 20px;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
`;

export default function SidePanel(props: IProps) {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const appSettingsContext = useContext(AppSettingsContext);
    useTranslation("", { useSuspense: true });

    const toggleSidePanel = () => {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        if (appSettingsContext.isMobileBottomPanelOpen !== undefined) {
            setIsOpen(appSettingsContext.isMobileBottomPanelOpen);
        }
    }, [appSettingsContext.isMobileBottomPanelOpen]);

    return <SidePanelContainer isOpen={isOpen} isMobile={appSettingsContext.isMobile}>
        {appSettingsContext.isMobile === false && <SidePanelBorderContainer />}
        <ContentsContainer isOpen={isOpen} isMobile={appSettingsContext.isMobile}>
            <Suspense fallback={<Spin size='large' />}>
                {props.children}
            </Suspense>
        </ContentsContainer>
        {appSettingsContext.isMobile === false && <SidePanelToggleControl onClick={toggleSidePanel} isOpen={isOpen}>
            {isOpen ? <CaretRightFilled /> : <CaretLeftFilled />}
        </SidePanelToggleControl>}
    </SidePanelContainer>
}